import React, { useCallback, useState } from "react";
import { Banner, Body, Button, Container, Footer, Header, Price, Title } from "./styles";
import imgDefault from "../../../assets/default.svg";
import { formattedPrice, isEmpty } from "../../../utils";
import ModalDescription from "../ModalDescription";
import { useDispatch, useSelector } from "react-redux";
import { setProductForCheckout } from "../../../store/modules/billingPlan/actions";
import { Product } from "../../../utils/constants";
import { Checkbox } from "../../Checkbox";

const MicroServiceCard = ({ data, onChange }) => {
	const dispatch = useDispatch();

	const { productSelected } = useSelector((state) => state.billingPlan);

	const { title, description, descriptionPros, price, banner, cdMicroService, dataComplete } = data;

	const [openModal, setOpenModal] = useState(false);

	function handleModal() {
		setOpenModal(!openModal);
	}

	const select = useCallback(
		(param, name) => {
			const find = productSelected.filter((id) => id === param);

			if (!isEmpty(find)) {
				const unselected = productSelected.filter((id) => id !== param);
				dispatch(setProductForCheckout(unselected, Product.MICRO_SERVICE));

				const nameProduct =
					unselected.length &&
					dataComplete.find((item) =>
						unselected.includes(item.cd_micro_service)
					).ds_micro_service;
				onChange(unselected.length === 1 ? nameProduct : "Loja");
				return;
			}

			if (productSelected.length) {
				dispatch(
					setProductForCheckout(
						[...productSelected, param],
						Product.MICRO_SERVICE
					)
				);
				onChange("Loja");
			} else {
				dispatch(setProductForCheckout([param], Product.MICRO_SERVICE));
				onChange(name);
			}
		},
		[productSelected, dataComplete, dispatch, onChange]
	);

	return (
		<Container>
			<Header onClick={handleModal}>
				<Banner
					src={banner.match(/\.(jpeg|jpg|gif|png)$/) ? banner : imgDefault}
					alt={title}
				/>
				<Title>{title}</Title>
			</Header>
			<Body>
				<Price>{formattedPrice(price)}/mês</Price>
				<Button type="button" onClick={handleModal}>
					Ver vantagens
				</Button>
			</Body>
			<Footer>
				<Checkbox
					id={cdMicroService}
					label={"Selecionar"}
					onChange={() => select(cdMicroService, title)}
				/>
			</Footer>
			{openModal && (
				<ModalDescription
					show={openModal}
					handleClose={handleModal}
					description={description}
					descriptionPros={descriptionPros}
					title={title}
				/>
			)}
		</Container>
	);
};

export default MicroServiceCard;
